var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        title: "ÁREA DE ATENDIMENTO",
        subtitle: "Busque os bairros pela cidade",
        size: "md"
      },
      on: {
        close: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _c("Autocomplete", {
            attrs: {
              label: "cidade",
              selected: _vm.city,
              results: _vm.cities,
              preloader: _vm.preloaderSearch,
              labels: ["display_name"]
            },
            on: { search: _vm.search, select: _vm.select, clear: _vm.clear }
          }),
          _vm._v(" "),
          _vm.city && _vm.city.districts.length
            ? _c("Districts", {
                attrs: { districts: _vm.city.districts, list: _vm.list },
                on: { toggleFromList: _vm.toggleFromList }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "v-btn",
            {
              attrs: { color: "primary", outlined: "", small: "" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_c("span", [_vm._v("fechar")])]
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { color: "primary", small: "", loading: _vm.preloader },
              on: { click: _vm.submit }
            },
            [_c("span", [_vm._v("cadastrar")])]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e5897f9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e5897f9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Coupons/AddDistricts/Index.vue
// module id = null
// module chunks = 